import store from '@/store'

export default function useUsuario() {
    function isUsuarioMarcasProprias() {
      if (!store) return false;
      const usuario = store.getters.getUsuario;
      return usuario.tipo_cargo === 'fornecedor' && usuario.cargo === 'Marcas Próprias';
    }

    return {
        isUsuarioMarcasProprias,
    };
}
